import "@/App.css";
import "@/index.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import RadioPage from "@/pages/RadioPage";
import LiveTV from "@/pages/LiveTV";
import VodLibrary from "@/pages/VodLibrary";
import Watch from "@/pages/Watch";
import SchedulePage from "@/pages/SchedulePage";
import NewsPage from "@/pages/NewsPage";
import Programs from "@/pages/Programs";
import Pricing from "@/pages/Pricing";
import About from "@/pages/About";
import Profile from "@/pages/Profile";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import RefundPolicy from "@/pages/RefundPolicy";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";
import FootballMatch from "@/pages/FootballMatch";
import EastAfrica from "@/pages/EastAfrica";
import EastAfricaMatch from "@/pages/EastAfricaMatch";
import FootballTeam from "@/pages/FootballTeam";
import FootballPlayer from "@/pages/FootballPlayer";
import Vote from "@/pages/Vote";
import VoteDetail from "@/pages/VoteDetail";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import { MyTickets, TicketView } from "@/pages/Tickets";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminHome from "@/pages/admin/AdminHome";
import AdminShows from "@/pages/admin/AdminShows";
import AdminLive from "@/pages/admin/AdminLive";
import AdminNews from "@/pages/admin/AdminNews";
import AdminSchedule from "@/pages/admin/AdminSchedule";
import AdminPrograms from "@/pages/admin/AdminPrograms";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminPayments from "@/pages/admin/AdminPayments";
import AdminApiManagement from "@/pages/admin/AdminApiManagement";
import AdminRevenueSplit from "@/pages/admin/AdminRevenueSplit";
import AdminVisitors from "@/pages/admin/AdminVisitors";
import AdminStoreAssets from "@/pages/admin/AdminStoreAssets";
import AdminUtilities from "@/pages/admin/AdminUtilities";
import AdminMerchants from "@/pages/admin/AdminMerchants";
import AdminCommissions from "@/pages/admin/AdminCommissions";
import BroadcasterPage from "@/pages/BroadcasterPage";
import MerchantPage from "@/pages/MerchantPage";
import PayMerchantPage from "@/pages/PayMerchantPage";
import MerchantDirectory from "@/pages/MerchantDirectory";
import UtilitiesPage from "@/pages/UtilitiesPage";
import HighlightsPage from "@/pages/HighlightsPage";
import AdminRecovery from "@/pages/admin/AdminRecovery";
import AdminReports from "@/pages/admin/AdminReports";
import AdminSettings from "@/pages/admin/AdminSettings";
import AdminSupport from "@/pages/admin/AdminSupport";
import AdminVoting from "@/pages/admin/AdminVoting";
import AdminEngagement from "@/pages/admin/AdminEngagement";
import AdminEvents from "@/pages/admin/AdminEvents";
import Scanner from "@/pages/admin/Scanner";
import AdminJournalists from "@/pages/admin/AdminJournalists";
import AdminHomepage from "@/pages/admin/AdminHomepage";
import AdminStaff from "@/pages/admin/AdminStaff";
import AdminApprovals from "@/pages/admin/AdminApprovals";
import AdminActivity from "@/pages/admin/AdminActivity";
import AdminMessages from "@/pages/admin/AdminMessages";
import Creators from "@/pages/Creators";
import CreatorProfile from "@/pages/CreatorProfile";
import CreatorVideo from "@/pages/CreatorVideo";
import CreatorStudio from "@/pages/CreatorStudio";
import Football from "@/pages/Football";
import FootballCompetition from "@/pages/FootballCompetition";
import AdminCreators from "@/pages/admin/AdminCreators";
import AdminFootball from "@/pages/admin/AdminFootball";
import AdminVOD from "@/pages/admin/AdminVOD";
import AdminPricing from "@/pages/admin/AdminPricing";
import AdminNotifications from "@/pages/admin/AdminNotifications";
import AdminAds from "@/pages/admin/AdminAds";
import CloudVideos from "@/pages/CloudVideos";
import VodPlayer from "@/pages/VodPlayer";
function App() {
  return (
    <AuthProvider>
      <PlayerProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Toaster position="top-center" theme="dark" richColors />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/radio" element={<RadioPage />} />
              <Route path="/live" element={<LiveTV />} />
              <Route path="/vod" element={<VodLibrary />} />
              <Route path="/watch/:id" element={<Watch />} />
              <Route path="/schedule" element={<SchedulePage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/utilities" element={<UtilitiesPage />} />
              <Route path="/merchant" element={<MerchantPage />} />
              <Route path="/pay" element={<PayMerchantPage />} />
              <Route path="/merchants" element={<MerchantDirectory />} />
              <Route path="/highlights" element={<HighlightsPage />} />
              <Route path="/programs" element={<Programs />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/vote" element={<Vote />} />
              <Route path="/vote/:id" element={<VoteDetail />} />
              <Route path="/events" element={<Events />} />
              <Route path="/events/:id" element={<EventDetail />} />
              <Route path="/creators" element={<Creators />} />
              <Route path="/creators/:slug" element={<CreatorProfile />} />
              <Route path="/creator-video/:id" element={<CreatorVideo />} />
              <Route path="/studio" element={<CreatorStudio />} />
              <Route path="/football" element={<EastAfrica scope="world" />} />
              <Route path="/football/classic" element={<Football />} />
              <Route path="/football/east-africa" element={<EastAfrica />} />
              <Route path="/football/east-africa/match/:key" element={<EastAfricaMatch />} />
              <Route path="/football/match/:id" element={<FootballMatch />} />
              <Route path="/football/team/:id" element={<FootballTeam />} />
              <Route path="/football/player/:id" element={<FootballPlayer />} />
              <Route path="/football/:slug" element={<FootballCompetition />} />
              <Route path="/videos" element={<CloudVideos />} />
              <Route path="/videos/:id" element={<VodPlayer />} />
              <Route path="/my-tickets" element={<MyTickets />} />
              <Route path="/ticket/:code" element={<TicketView />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/broadcast" element={<BroadcasterPage />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/refund-policy" element={<RefundPolicy />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<AdminHome />} />
              <Route path="approvals" element={<AdminApprovals />} />
              <Route path="staff" element={<AdminStaff />} />
              <Route path="activity" element={<AdminActivity />} />
              <Route path="shows" element={<AdminShows />} />
              <Route path="live" element={<AdminLive />} />
              <Route path="news" element={<AdminNews />} />
              <Route path="schedule" element={<AdminSchedule />} />
              <Route path="programs" element={<AdminPrograms />} />
              <Route path="users" element={<AdminUsers />} />
              <Route path="voting" element={<AdminVoting />} />
              <Route path="engagement" element={<AdminEngagement />} />
              <Route path="events" element={<AdminEvents />} />
              <Route path="scanner" element={<Scanner />} />
              <Route path="homepage" element={<AdminHomepage />} />
              <Route path="journalists" element={<AdminJournalists />} />
              <Route path="payments" element={<AdminPayments />} />
              <Route path="api-management" element={<AdminApiManagement />} />
              <Route path="revenue-split" element={<AdminRevenueSplit />} />
              <Route path="visitors" element={<AdminVisitors />} />
              <Route path="store-assets" element={<AdminStoreAssets />} />
              <Route path="utilities" element={<AdminUtilities />} />
              <Route path="merchants" element={<AdminMerchants />} />
              <Route path="commissions" element={<AdminCommissions />} />
              <Route path="recovery" element={<AdminRecovery />} />
              <Route path="reports" element={<AdminReports />} />
              <Route path="support" element={<AdminSupport />} />
              <Route path="settings" element={<AdminSettings />} />
              <Route path="pricing" element={<AdminPricing />} />
              <Route path="messages" element={<AdminMessages />} />
              <Route path="notifications" element={<AdminNotifications />} />
              <Route path="ads" element={<AdminAds />} />
              <Route path="creators" element={<AdminCreators />} />
              <Route path="football" element={<AdminFootball />} />
              <Route path="vod" element={<AdminVOD />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </PlayerProvider>
    </AuthProvider>
  );
}

export default App;
